/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import appRoutes from "../../routes/appRoutes";

import Error from "../../components/error";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import SuccessMsg from "../../components/successMsg";

import Label from "../../components/label";
// import Anchor from "../../components/anchor";
import { NavLink } from "react-router-dom";

const ForgotPasswordForm = props => {
  const formik = useFormik({
    initialValues: {
      email: ""
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .min(7, "Email must be of minimum length 7")
        .email("Please provide a valid email address")
        .required("Please enter the email address")
    }),
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });
  return (
    <form
      className="d-flex flex-column align-items-center forgot-form p-0"
      onSubmit={formik.handleSubmit}
    >
      <Label
        title="A link will be sent to your email address so you can reset your password"
        className="gray"
      />
      <Label
        title="Email Address"
        className="gray text-left mt-2 ex-small w-75"
        required={true}
      />
      <ICInput
        id="email"
        name="email"
        type="text"
        label=""
        className="w-75"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.email}
        error={formik.touched.email && formik.errors.email ? true : false}
        helperText={
          formik.touched.email && formik.errors.email ? formik.errors.email : ""
        }
      />
      <br />
      <Button className="mt-2" title="Submit" type="submit" />
      <br />
      <NavLink
        to={appRoutes.login}
        className="insta-link-default font-14 pb-3"
        href="/"
      >
        <span className="ml-2 pt-1">Back to login</span>
      </NavLink>
      {/* <Anchor
        className="insta-link-grey font-14"
        title="Back to login"
        href={appRoutes.login}
      /> */}
      <Error>{props.serverErrorMsg}</Error>
      <SuccessMsg>{props.successMsg}</SuccessMsg>
    </form>
  );
};

export default ForgotPasswordForm;

ForgotPasswordForm.defaultProps = {
  serverErrorMsg: "",
  successMsg: ""
};

ForgotPasswordForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string,
  successMsg: PropTypes.string
};
